import React from 'react';
import SnackBarClose from '../../../Media/InboxV1/SnackBarClose';

const SnackBarCloseIcon = ({ onClick }) => {
  return <SnackBarClose onClick={onClick} className="snack-close" />;
};

export default SnackBarCloseIcon;
